module.exports = __webpack_public_path__ + "static/screen-plan-today.a1ff5c14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stronglist/screen-plan-today.jpg
// module id = 383
// module chunks = 212420072151734